module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popups/my-stuff/removed-items/removed-items.component.less
// module id = ./src/app/components/popups/my-stuff/removed-items/removed-items.component.less
// module chunks = main